export default {
  init: function init() {
    //Parallax placeholder height
    $('.exhibitions-section .exhibition-container').addClass('parallax');
    var windowHeight = $(window).height();
    var parallaxTop = $('.parallax-container').offset().top + 24;
    var parallaxBottom = $('.parallax-container').offset().top - $('.parallax-container').height() - $(window).height();
    var prevScroll = 0;
    var scrollDirection = 'down';
    $(window).on('scroll', function () {
      var scrollPosition = $(window).scrollTop();

      if (scrollPosition > prevScroll) {
        scrollDirection = 'down';
      } else {
        scrollDirection = 'up';
      }

      var offset = scrollPosition - parallaxTop;

      if (offset < 1) {
        $('.exhibitions-section .progress').css('width', '0');
      } else if (offset / $('.exhibition-container.parallax').height() < 1) {
        $('.exhibitions-section .progress').css('width', offset / $('.exhibition-container.parallax').height() * 100 + '%');
      } else {
        $('.exhibitions-section .progress').css('width', '100%');
      }

      if (offset > 0 && offset <= $('.parallax-placeholder').height()) {
        $('.exhibitions-section .col').css('transform', 'translateY(-' + offset + 'px)');
      } else if (offset < 0) {
        $('.exhibitions-section .col').css('transform', 'translateY(0)');
      }

      var crtrOffset = scrollPosition - $('.creators-container').offset().top + 120;

      if (crtrOffset < 1) {
        $('#creators-section .progress').css('width', '0');
      } else if (crtrOffset / $('.creators-container').height() < 1) {
        $('#creators-section .progress').css('width', crtrOffset / $('.creators-container').height() * 100 + '%');
      } else {
        $('#creators-section .progress').css('width', '100%');
      }
    });
    $(window).on('load', function () {
      var scrollPosition = $(window).scrollTop();
      var offset = scrollPosition - parallaxTop;

      if (offset > 0 && offset <= $('.parallax-placeholder').height()) {
        $('.exhibitions-section .col').css('transform', 'translateY(-' + offset + 'px)');
      } else if (offset < 0) {
        $('.exhibitions-section .col').css('transform', 'translateY(0)');
      } else if (offset > $('.parallax-placeholder').height()) {
        $('.exhibitions-section .col').css('transform', "translateY(-".concat($('.parallax-placeholder').height(), "px)"));
      }
    });
  },
  finalize: function finalize() {
    $('input[name="query"]').on('keyup', function () {
      if ($(this).val() !== '') {
        $(this).addClass('not-empty');
      } else {
        $(this).removeClass('not-empty');
      }
    });
    $('.clear-input').on('click', function (e) {
      e.preventDefault();
      $(this).siblings('input[name="query"]').val('').removeClass('not-empty');
      $('.headline-wrapper form button').trigger('click');
    });

    if ($('input[name="query"]').val() !== '') {
      $('input[name="query"]').addClass('not-empty');
    }
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/exhibition-landing.js